/**
 * KYC Modal
 * @description KYC Modal
 * @author Tirumal Rao
 */
import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Button, Image } from 'semantic-ui-react';
import { popupwindow, getCDNpath } from '../../app/common/util';
import './modal.css';

const KYCImage = getCDNpath('/static/images/kycicon.jpg');

class KYCModal extends Component {
  static propTypes = {
    payload: PropTypes.object.isRequired
  };

  // init component state
  state = {};

  update = () => {
    const {
      payload: { isLoggedIn }
    } = this.props;

    if (isLoggedIn.url) {
      popupwindow(isLoggedIn.url, 'Freecharge KYC', window, 800, 650);
    }
  };

  render() {
    const {
      payload: { closeModal }
    } = this.props;

    return (
      <Modal id="kycModal" size="tiny" open={true}>
        <Modal.Content>
          <Modal.Description style={{textAlign: 'center'}}>
            <Image src={KYCImage} alt="" size="small" />
            <h2>Update your KYC with FreeCharge</h2>
            <p>
              As per RBI guidelines, please update your basic KYC details. It
              will take less than 2 minutes. You might not be able to use
              certain features until then.
            </p>
            <br /><br />
            <Button
              className="fcbtn fcprimary small remindMeLater"
              type="submit"
              onClick={closeModal}
            >
              REMIND ME LATER
            </Button>
            <Button
              className="fcbtn fcprimary small"
              type="submit"
              onClick={this.update}
            >
              UPDATE
            </Button>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }

  componentWillUnmount() {}
}

export default KYCModal;
